<template>
  <div class="text-left px-6 pb-12 bg-gray-50">
    <div class="absolute mt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="text-center text-sm font-extrabold w-full pt-12">ORDER SUMMARY</div>
    <div class="pt-7">
      <div class="rounded-2xl shadow-md px-5 py-6 border border-gray-100 flex">
        <div class="pr-4 pt-4">
          <route-icon></route-icon>
        </div>
        <div>
          <div class="text-xs">
            <p class="text-nw-ash">Pick-up Location</p>
            <p class="font-bold">
              {{ details ? details.pick_up.location : '' }}
            </p>
          </div>
          <div class="border-b pt-4"></div>
          <div class="text-xs pt-4">
            <p class="text-nw-ash">Drop-off Location</p>
            <p class="font-bold">
              {{ details ? details.delivering.location : '' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-3">
      <div class="rounded-2xl shadow-md px-5 py-6 bg-nw-red border border-nw-red text-xs text-white">
        <div class="font-extrabold pb-1">Pick Up</div>
        <div class="border-b border-white"></div>
        <div class="pt-4">Name</div>
        <div class="pt-1 font-extrabold">{{ details.pick_up.sender_name }}</div>
        <div class="pt-4">Phone Number</div>
        <div class="pt-1 font-extrabold">{{ details.pick_up.phone_number }}</div>
      </div>
    </div>
    <div class="pt-3">
      <div class="rounded-2xl shadow-md px-5 py-6 bg-white border border-gray-100 text-xs text-gray-800">
        <div class="font-extrabold pb-1">Delivery</div>
        <div class="border-b"></div>
        <div class="pt-4">Name</div>
        <div class="pt-1 font-extrabold">{{ details.delivering.receiver_name }}</div>
        <div class="pt-4">Phone Number</div>
        <div class="pt-1 font-extrabold">{{ details.delivering.phone_number }}</div>
      </div>
    </div>
    <div class="pt-7 text-xs" @click="end">
      <input-button>CONFIRM ORDER</input-button>
    </div>
    <div class="fixed left-0 top-0 w-full bg-dark-transparent h-screen" v-if="loading">
      <div class="absolute top-2/4 w-full">
        <loading :width="'w-10'" :height="'h-10'"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import BackArrowIcon from '../icons/BackArrowIcon.vue'
import RouteIcon from '../icons/RouteIcon.vue'
import InputButton from '../inputs/InputButton.vue'
import Loading from '../icons/Loading.vue'
//import uniqid from 'uniqid'
//import flutterwave from '@/services/flutterwave.js'

export default {
  props: {
    id: [String, Number]
  },
  components: { BackArrowIcon, RouteIcon, InputButton, Loading },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('arrange_details', ['details']),
    user_details() {
      return this.$store.state.user_details
    },
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    back() {
      this.$emit('show-payment', true)
    },
    end() {
      //flutterwave.sendRequest()
      if (this.details.payment_details.payment_type == 'With card') {
        this.callFlutterwave()
      } else {
        Swal.fire({
          text: 'Confirm Order?',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: `Confirm`,
          denyButtonText: ``
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Your Order is being processed',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.$store.dispatch('add_payment_details/finishOrder', this.id).then(() => {
                this.$router.push({
                  name: 'Dashboard'
                })
              })
            })
          }
        })
      }
    },
    callFlutterwave() {
      var uniqueId = this.id
      if (process.env.NODE_ENV === 'production') {
        var public_key = 'FLWPUBK-fac232adab3d41f0d5d5678d74ad5787-X'
      } else {
        public_key = 'FLWPUBK_TEST-e65e01b2c553c3048af0a85fb7e7e792-X'
      }
      this.loading = true
      //eslint-disable-next-line no-undef
      FlutterwaveCheckout({
        public_key: public_key,
        tx_ref: uniqueId,
        amount: this.details.payment_details.total,
        currency: 'NGN',
        country: 'NG',
        payment_options: 'card, banktransfer, ussd',
        meta: {
          consumer_id: this.user.uid
          //consumer_mac: '92a3-912ba-1192a'
        },
        customer: {
          email: this.user_details.email,
          phone_number: this.user.phoneNumber,
          name: this.user_details.first_name + ' ' + this.user_details.last_name
        },
        callback: data => {
          var payment_made = {
            amount: data.amount,
            status: data.status,
            transaction_id: data.transaction_id,
            tx_ref: data.tx_ref,
            created_at: Date.now(),
            payment_method: 'flutterwave'
          }
          this.$store.dispatch('add_payment_details/makeCardPayment', payment_made).then(() => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Your Order is being processed',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.$router.push({
                name: 'Dashboard'
              })
            })
          })
        },
        onclose: () => {
          //
        }
        /*customizations: {
          title: 'My store',
          description: 'Payment for items in cart',
          logo: 'https://assets.piedpiper.com/logo.png'
        }*/
      })
    },
    addScript() {
      var head = document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://checkout.flutterwave.com/v3.js'
      head.appendChild(script)
    },
    removeScript() {
      var head = document.getElementsByTagName('head')[0]
      var scripts = document.getElementsByTagName('script')
      scripts.forEach(script => {
        if (script.src == 'https://checkout.flutterwave.com/v3.js') {
          head.removeChild(script)
        }
      })
      var links = document.getElementsByTagName('link')
      links.forEach(link => {
        if (link.href == 'https://assets.flutterwave.com/assets/light.css') {
          head.removeChild(link)
        }
      })
    }
  },
  created() {
    this.$store.dispatch('arrange_details/getOrderArrangements', this.id)
    this.addScript()
  },
  beforeDestroy() {
    //this.removeScript()
  }
}
</script>
